// extracted by mini-css-extract-plugin
export var flex = "sizeCards-module--flex--zbSxF";
export var img = "sizeCards-module--img--QywlP";
export var info_container = "sizeCards-module--info_container--e+4lz";
export var row = "sizeCards-module--row--s1ANB";